// Copyright (c) 2016 Deere & Company

import Accordions, {getDefaultState as getAccordionsDefaultState} from './accordions';
import AmountOfUseHistory, {getDefaultState as getAmountOfUseHistoryDefaultState} from './amount-of-use-history';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Claims, {getDefaultState as getClaimsDefaultState} from './claims';
import Component, {getDefaultState as getComponentDefaultState} from '@deere/cps-it.warranty-model-factory/lib/component';
import ComponentCodes, {getDefaultState as getComponentCodesDefaultState} from './component-codes';
import Components, {getDefaultState as getComponentsDefaultState} from './components';
import CreateClaimModal, {getDefaultState as getCreateClaimModalDefaultState} from '../../../shared/state/create-claim-modal';
import Customer, {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import ExternalNotes, {getDefaultState as getExternalNotesDefaultState} from '@deere/cps-it.warranty-model-factory/lib/external-notes';
import Implements, {getDefaultState as getImplementsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/implements';
import IncentivePrograms, {getDefaultState as getIncentiveDefaultState} from './incentive-programs';
import MaintenancePlans, {getDefaultState as getMaintenancePlansDefaultState} from './maintenance-plans';
import Option, {getDefaultState as getOptionDefaultState} from '@deere/cps-it.warranty-model-factory/lib/option';
import OptionCodes, {getDefaultState as getOptionCodesDefaultState} from './option-codes';
import Pips, {getDefaultState as getPipsDefaultState} from './pips';
import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import ProductDetailsStatusChangeModal, {getDefaultState as getProductDetailsStatusChangeModalDefaultState} from './product-details-status-change-modal';
import RegistrationHistoryList, {getDefaultState as registrationHistoryListDefaultState} from './registration-history';
import Warranties, {getDefaultState as getWarrantiesDefaultState} from './warranties';
import t from 'tcomb';

const State = t.struct({
    accordions: Accordions,
    amountOfUseHistory: AmountOfUseHistory,
    baseMachineComponents: Implements,
    baseMachinePurchaseOrder: t.String,
    busyCounter: BusyCounter,
    claims: Claims,
    componentCodes: ComponentCodes,
    componentToAdd: Component,
    components: Components,
    createClaimModal: CreateClaimModal,
    customer: Customer,
    externalNotes: ExternalNotes,
    incentivePrograms: IncentivePrograms,
    isAmountOfUseEditModalOpen: t.Boolean,
    isAmountOfUseModalOpen: t.Boolean,
    maintenancePlans: MaintenancePlans,
    optionCodes: OptionCodes,
    optionToAdd: Option,
    pips: Pips,
    product: Product,
    productDetailsStatusChangeModal: ProductDetailsStatusChangeModal,
    registrationHistoryList: RegistrationHistoryList,
    showAddComponentRow: t.Boolean,
    warranties: Warranties
}, 'State');

export const getDefaultState = () =>
    new State({
        accordions: getAccordionsDefaultState(),
        amountOfUseHistory: getAmountOfUseHistoryDefaultState(),
        baseMachineComponents: getImplementsDefaultState(),
        baseMachinePurchaseOrder: '',
        busyCounter: getBusyCounterDefaultState(),
        claims: getClaimsDefaultState(),
        componentCodes: getComponentCodesDefaultState(),
        componentToAdd: getComponentDefaultState(),
        components: getComponentsDefaultState(),
        createClaimModal: getCreateClaimModalDefaultState(),
        customer: getCustomerDefaultState(),
        externalNotes: getExternalNotesDefaultState(),
        incentivePrograms: getIncentiveDefaultState(),
        isAmountOfUseEditModalOpen: false,
        isAmountOfUseModalOpen: false,
        maintenancePlans: getMaintenancePlansDefaultState(),
        optionCodes: getOptionCodesDefaultState(),
        optionToAdd: getOptionDefaultState(),
        pips: getPipsDefaultState(),
        product: getProductDefaultState(),
        productDetailsStatusChangeModal: getProductDetailsStatusChangeModalDefaultState(),
        registrationHistoryList: registrationHistoryListDefaultState(),
        showAddComponentRow: false,
        warranties: getWarrantiesDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/product/details/state/index.js